export const ONCO_CARE_MAX_AGE = 80;
export const ONCO_CARE_MIN_AGE = 18;
export const ONCO_CARE_CHILD_MIN_AGE = 1;
export const ONCO_CARE_CHILD_MAX_AGE = 21;
export const ONCOCARE_PREFIX = 'oncocare';
export const ONCOCARE_GET_MOBILE_CONTRACT_PREFIX = 'oncocare-contract/get-mobile-contract';
export const ONCO_CARE_CONTRACT_LINK = {
  hy: 'https://www.efes.am/efesoncocare',
  en: 'https://www.efes.am/en/efesoncocare',
};
